import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Grid from '@material-ui/core/Grid';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import AutosuggestField from 'components/fields/AutosuggestField';

import {
  requestFetchPrescribers,
  requestSearchPrescribers,
} from 'redux/modules/prescribers';
import { accountLoginFail } from 'redux/modules/account';
import { saveRecoverOrder } from 'redux/modules/recoverOrder';

import formatPrescriberName from 'utils/formatPrescriberName';

function onSubmit(values, dispatch, props) {
  const normalizeValues = (formValues) => {
    const normalizedValues = Object.assign({}, formValues);

    delete normalizedValues['Selected Name'];

    return normalizedValues;
  };
  if (values.ID !== null) {
    props.reset();
    return normalizeValues(values);
  }
  throw new SubmissionError({ ID: 'Field is required' });
}

function onChange(values, dispatch, props) {
  if (props.variant === 'default' && values.ID !== null) {
    props.submit();
  }
}

const PrescribersAddForm = ({
  className,
  handleSubmit,
  disabled,
  change,
  onCreateButtonClick,
  variant,
  actions,
  formValues,
  account,
  prescriber,
}) => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
    className={className}
    role="presentation"
    onKeyDown={(event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        event.stopPropagation();
      }
    }}
  >
    <Grid container justify="center" spacing={24}>
      <Grid item xs={12}>
        <Field
          id="Name"
          name="Name"
          component={AutosuggestField}
          placeholder="Search by Name or NPI / LIC"
          fullWidth
          disabled={disabled}
          onListAdornmentClick={() => {
            change('Name', '');
            onCreateButtonClick();
          }}
          listAdornmentText="Add new"
          renderSuggestionContent={suggestion => (
            formatPrescriberName(suggestion)
          )}
          renderInputContent={suggestion => (
            formatPrescriberName(suggestion)
          )}
          onSuggestionSelected={(suggestion) => {
            change('ID', suggestion.ID);
            change('Referral Source', suggestion['Referral Source']);
            change('First Name', suggestion['First Name']);
            change('Last Name', suggestion['Last Name']);
            if (variant === 'dialog') {
              return formatPrescriberName(suggestion);
            }
            return '';
          }}
          fetchSuggestions={({ value, limit, offset }) => (
            value.length > 0 || prescriber.length > 0
              ? requestSearchPrescribers({
                filters: [
                  ...value.length > 0 ? [{
                    name: /\d/.test(value) ? 'Prescriber NPI-LIC Code' : 'Full Name',
                    operation: /\d/.test(value) ? 'contains' : 'startswith',
                    val: value,
                    case_sensitivity: false,
                  }] : [],
                  ...prescriber.length > 0 ? [{
                    name: 'ID',
                    operation: 'nin',
                    val: prescriber.map(item => item.ID),
                  }] : [],
                ],
                limit,
                offset,
              }).then(res => res.data,
                (error) => {
                  if (variant === 'dialog' && error.data.error === 'Access Error') {
                    actions.saveRecoverOrder({
                      [account.ID]: {
                        ...formValues,
                        timestamp: new Date().getTime(),
                      },
                    });
                    actions.accountLoginFail();
                  }
                  return error;
                })
              : requestFetchPrescribers({
                limit,
                offset,
              }).then(res => res.data,
                (error) => {
                  if (variant === 'dialog' && error.data.error === 'Access Error') {
                    actions.saveRecoverOrder({
                      [account.ID]: {
                        ...formValues,
                        timestamp: new Date().getTime(),
                      },
                    });
                    actions.accountLoginFail();
                  }
                  return error;
                })
          )}
          onlyConfirmedSelection
        />
      </Grid>
    </Grid>
  </form>
);

PrescribersAddForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  className: PropTypes.string,
  onCreateButtonClick: PropTypes.func,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'dialog']),
  account: PropTypes.shape({
    ID: PropTypes.number.isRequired,
  }).isRequired,
  formValues: PropTypes.shape({
    'Primary Insurance ID': PropTypes.number,
  }),
  actions: PropTypes.shape({
    accountLoginFail: PropTypes.func.isRequired,
    saveRecoverOrder: PropTypes.func.isRequired,
  }).isRequired,
  prescriber: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })),
};

PrescribersAddForm.defaultProps = {
  variant: 'default',
  className: '',
  disabled: false,
  onCreateButtonClick: () => {},
  formValues: {},
  prescriber: [],
};

const mapStateToProps = store => ({
  account: store.account,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    accountLoginFail,
    saveRecoverOrder,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'patientPrescribersAdd',
  onSubmit,
  onChange,
  initialValues: {
    ID: null,
  },
})(PrescribersAddForm));



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/Prescribers/PrescribersAddForm.js